"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkElementDestination = void 0;
var tslib_1 = require("tslib");
var string_1 = require("@devexpress/utils/lib/utils/string");
var import_bookmark_info_1 = require("../../model/import-bookmark-info");
var destination_1 = require("../destination");
var BookmarkElementDestination = (function (_super) {
    tslib_1.__extends(BookmarkElementDestination, _super);
    function BookmarkElementDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BookmarkElementDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, name, bookmark;
            return tslib_1.__generator(this, function (_a) {
                id = reader.getAttributeNS('id', this.data.constants.wordProcessingNamespaceConst);
                if (id != null)
                    id = string_1.StringUtils.trim(id);
                if (string_1.StringUtils.isNullOrEmpty(id))
                    return [2];
                name = reader.getAttributeNS('name', this.data.constants.wordProcessingNamespaceConst);
                if (!string_1.StringUtils.isNullOrEmpty(name))
                    name = string_1.StringUtils.trim(name);
                bookmark = this.data.subDocumentInfo.bookmarkImporter.bookmarks[id];
                if (!bookmark) {
                    bookmark = new import_bookmark_info_1.ImportBookmarkInfo();
                    bookmark.name = name;
                    this.data.subDocumentInfo.bookmarkImporter.bookmarks[id] = bookmark;
                }
                this.assignBookmarkPosition(bookmark);
                return [2];
            });
        });
    };
    return BookmarkElementDestination;
}(destination_1.LeafElementDestination));
exports.BookmarkElementDestination = BookmarkElementDestination;
